import { useQueryClient } from 'react-query';
import { OnsiteCampaign } from '../context/OnsiteCampaignSectionState';

export function useOnsiteCampaignsCache(siteId: string) {
  const queryClient = useQueryClient();
  const addCampaignToCache = (newCampaign: OnsiteCampaign) => {
    queryClient.setQueryData(['onsite-campaigns', siteId], (old: OnsiteCampaign[] = []) => [newCampaign, ...old]);
  };
  return { addCampaignToCache };
}
